<template>
  <div class="siderbar">
    <avatar></avatar>
    <!-- <el-scrollbar> -->
    <el-menu
      mode="vertical"
      :default-active="activeMenu"
      class="el-menu-vertical-demo"
      background-color="#242e37"
      text-color="#D7DEE4"
      active-text-color="#ff6224"
      unique-opened
    >
      <sidebar-item
        v-for="route in permission_routes"
        :key="route.path"
        :item="route"
        :base-path="route.path"
      />
    </el-menu>
    <!-- </el-scrollbar> -->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import SidebarItem from "./SidebarItem";
import Avatar from "./../Avatar";
// import variables from '@/styles/variables.scss'

export default {
  components: { SidebarItem, Avatar },
  computed: {
    ...mapGetters(["permission_routes"]),
    activeMenu() {
      const route = this.$route;
      const { meta, path } = route;
      // if set path, the sidebar will highlight the path you set
      if (meta.activeMenu) {
        return meta.activeMenu;
      }
      return path;
    }
  }
};
</script>
<style lang="scss">
$commonFontSize: 14px;
.siderbar {
  background-color: #303a43;
  .el-menu-item {
    font-size: $commonFontSize;
    background-color: #242e37 !important;
    border-bottom: 1px solid rgb(33, 42, 50);
    text-align: left;
    padding-left: 50px !important;
  }
  .el-menu-item:hover {
    background-color: #1d252c !important;
  }
  .el-menu-item.is-active {
    background-color: #1d252c !important;
    color: #ff6224 !important;
    border-left: 2px solid #ff6224;
  }
  .el-menu {
    // border-left: 5px solid #ff6224;
    border: none;
  }
  .menu-warpper-msg {
    position: absolute;
    left: 100px;
    top: 7px;
    border: 1px solid #f00;
    height: 16px;
    line-height: 16px;
    border-radius: 8px;
    background-color: #f00;
    font-size: 12px;
    text-align: center;
    font-weight: bold;
    color: #fff;
    padding: 0 4px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/layout/SiderBar/index.vue